module.exports = __webpack_public_path__ + "img/core3.cab9199f.png";